import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';

import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  ConnectAccountToHeatpunkInput,
  ConnectAccountToHeatpunkMutation,
  DisconnectAccountFromHeatpunkMutation,
} from '../../../gql/graphql';

const CONNECT_ACCOUNT_TO_HEATPUNK = graphql(`
  mutation ConnectAccountToHeatpunk($input: ConnectAccountToHeatpunkInput!) {
    connectAccountToHeatpunk(input: $input) {
      __typename
      ... on ConnectAccountToHeatpunkSuccess {
        id
      }
      ... on ConnectAccountToHeatpunkError {
        message
      }
    }
  }
`);

export const useConnectAccountToHeatpunk = (
  options?: UseMutationOptions<
    ConnectAccountToHeatpunkMutation,
    unknown,
    ConnectAccountToHeatpunkInput
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(CONNECT_ACCOUNT_TO_HEATPUNK, {
        input,
      });
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};

const DISCONNECT_ACCOUNT_FROM_HEATPUNK = graphql(`
  mutation DisconnectAccountFromHeatpunk {
    disconnectAccountFromHeatpunk
  }
`);

export const useDisconnectAccountFromHeatpunk = (
  options?: UseMutationOptions<
    DisconnectAccountFromHeatpunkMutation,
    unknown,
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return gqlClient.request(DISCONNECT_ACCOUNT_FROM_HEATPUNK);
    },
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: meKeys.integrations() }),
    ...options,
  });
};
